module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"period":"Period","to":"To","start_date":"Start date","end_date":"End date"},"fr":{"period":"Période","to":"à","start_date":"Date de début","end_date":"Date de fin"},"de":{"period":"Zeitraum","to":"Zu","start_date":"Startdatum","end_date":"Endtermin"}}')
  delete Component.options._Ctor
}
